export const MAX_IMAGE_UPLOAD_BYTES = 1 * 1024 * 1024;
export const MAX_IMAGE_UPLOAD_LABEL = '1 MB';

export const ALLOWED_IMAGE_UPLOAD_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
];

/** @returns {string|null} Error message when invalid, null when OK */
export function validateImageUploadFile(file, { label = 'Image' } = {}) {
  if (!file) return null;
  if (!ALLOWED_IMAGE_UPLOAD_TYPES.includes(file.type)) {
    return `${label} must be JPEG, PNG, GIF, or WebP.`;
  }
  if (file.size > MAX_IMAGE_UPLOAD_BYTES) {
    return `${label} must not exceed ${MAX_IMAGE_UPLOAD_LABEL}.`;
  }
  return null;
}
